__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/2025-09-18-plaid/";